module.exports = __webpack_public_path__ + "static/media/bus-selected.90b11020.svg";